module.exports = __webpack_public_path__ + "img/blackCamera.841a34e6.svg";